<template>
  <div class="sibling-categories flex overflow-x-auto gap-4 scroll-smooth scrollbar-none">
    <PdpSiblingCategory
      v-for="category in limitedCategories"
      :key="category.slug"
      :category="category"
    />
  </div>
</template>
<script lang="ts">

import type { SiblingCategory } from '~~/types/product/ProductCategories';

export default defineComponent({
  name: 'PdpSiblingCategories',

  props: {
    categories: {
      type: Array as PropType<Array<SiblingCategory>>,
      required: true,
    },
  },
  setup(props) {

    const CATEGORIES_TO_DISPLAY = 5;
    const limitedCategories = computed(() => props.categories.slice(0, CATEGORIES_TO_DISPLAY));

    return { limitedCategories };
  
  },
});

</script>
<style lang="scss" scoped>
.sibling-categories {
  -ms-overflow-style: none;
  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
